import { render, staticRenderFns } from "./IzvestajiTroskoviVozila.vue?vue&type=template&id=e8341cea&scoped=true&"
import script from "./IzvestajiTroskoviVozila.vue?vue&type=script&lang=ts&"
export * from "./IzvestajiTroskoviVozila.vue?vue&type=script&lang=ts&"
import style0 from "./IzvestajiTroskoviVozila.vue?vue&type=style&index=0&id=e8341cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8341cea",
  null
  
)

export default component.exports